"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

require("./_primary-addons.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function PrimaryAddons(_ref) {
  var requestedAddons = _ref.requestedAddons,
      appliedAddons = _ref.appliedAddons,
      onChangeAddon = _ref.onChangeAddon;
  var duration = (0, _lodash.default)(requestedAddons, 'DURATION.value', 'STANDARD');
  var chromaKey = (0, _lodash.default)(requestedAddons, 'CHROMA_KEY.value', false);
  var rushEdit = (0, _lodash.default)(requestedAddons, 'RUSH_EDIT.value', '');
  return (/*#__PURE__*/_react.default.createElement("div", {
      className: "primary-addons"
    }, /*#__PURE__*/_react.default.createElement(_commonReact.RushEdit, {
      rushEdit: rushEdit,
      onChangeAddon: onChangeAddon
    }), /*#__PURE__*/_react.default.createElement(_uiKit.When, {
      condition: !appliedAddons.DURATION
    }, /*#__PURE__*/_react.default.createElement(_commonReact.Duration, {
      duration: duration,
      onChangeAddon: onChangeAddon
    })), /*#__PURE__*/_react.default.createElement(_uiKit.When, {
      condition: !appliedAddons.CHROMA_KEY
    }, /*#__PURE__*/_react.default.createElement(_commonReact.ChromaKey, {
      chromaKey: chromaKey,
      onChangeAddon: onChangeAddon
    })))
  );
}

var _default = (0, _react.memo)(PrimaryAddons);

exports.default = _default;